const steps = [
  {
    number: '01',
    title: 'Produkte finden',
    description: 'Durchsuche das OOPBuy Spreadsheet nach deinen Wunschprodukten. Tausende Artikel aus allen Kategorien warten auf dich.',
  },
  {
    number: '02',
    title: 'Spreadsheet öffnen',
    description: 'Öffne das Spreadsheet und navigiere durch die übersichtliche Kategorienstruktur. Alle Produkte sind klar geordnet.',
  },
  {
    number: '03',
    title: 'Zum Shop wechseln',
    description: 'Klicke auf den direkten Shop-Link und gelange sofort zum Verkäufer. Kein umständliches Suchen mehr.',
  },
  {
    number: '04',
    title: 'Bestellen',
    description: 'Lege das Produkt in den Warenkorb und schließe deine Bestellung ab. Sicher, schnell und unkompliziert.',
  },
];

export default function HowItWorksSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-gradient-to-b from-secondary-800 to-secondary-900">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100/20 text-secondary-100 text-xs font-medium mb-4">
            / So funktioniert&apos;s
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-4 max-w-2xl">
            In vier einfachen Schritten zum Wunschprodukt
          </h2>
          <p className="text-background-50/70 text-sm md:text-base leading-relaxed max-w-xl">
            Das OOPBuy Spreadsheet macht den Einkauf so einfach wie nie zuvor. Folge diesen vier Schritten und entdecke eine neue Art des Online-Shoppings.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-start gap-10">
          <div className="lg:w-[40%]">
            <div className="rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Minimal%20clean%20workspace%20scene%20with%20laptop%20displaying%20organized%20spreadsheet%20interface%20showing%20product%20catalog%20mockup%20on%20warm%20beige%20desk%20soft%20natural%20lighting%20editorial%20technology%20photography%20organized%20aesthetic%20professional%20setup%20with%20subtle%20styling%20elements&width=800&height=800&seq=how-it-works-preview-v2&orientation=squarish"
                alt="OOPBuy Spreadsheet Anleitung – Schritt für Schritt"
                title="OOPBuy Spreadsheet Anleitung"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="lg:w-[60%] space-y-8">
            {steps.map((step) => (
              <div key={step.number} className="flex gap-5 items-start">
                <span className="font-heading text-4xl md:text-5xl font-bold text-background-50/30 leading-none shrink-0">
                  {step.number}
                </span>
                <div>
                  <h3 className="text-lg md:text-xl font-heading font-bold text-background-50 mb-1">{step.title}</h3>
                  <p className="text-background-50/70 text-sm leading-relaxed">{step.description}</p>
                </div>
              </div>
            ))}
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-background-50 text-foreground-900 font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap mt-4"
            >
              Jetzt starten
              <i className="ri-arrow-right-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}